import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ProtectedRoute from './Components/ProtectedRoute';

import { TokenProvider } from './Contexts/TokenContext';

import Featured from './pages/Featured';
import Featureds from './pages/Featureds';
import Home from './pages/Home';
import HomeRedirect from './pages/HomeRedirect';
import Images from './pages/Images';
import Login from './pages/Login';
import Password from './pages/Password';
import Product from './pages/Product';
import Search from './pages/Search';
import Supplies from './pages/Supplies';
import Supply from './pages/Supply';
import Type from './pages/Type';
import Video from './pages/Video';
import Videos from './pages/Videos';
// import Ranking from './pages/Ranking';
import AcceptTerms from './pages/AcceptTerms';
import Birthday from './pages/Birthday';
import CompleteRegister from './pages/CompleteRegister';
import Contact from './pages/Contact';
import Download from './pages/Download';
import Profile from './pages/Profile';

import AdminAddSlide from './pages/Manager/AddSlide';
import AdminEditSlide from './pages/Manager/EditSlide';
import AdminHome from './pages/Manager/Home';
import AdminLogin from './pages/Manager/Login';

import AdminAddProduct from './pages/Manager/AddProduct';
import AdminEditProduct from './pages/Manager/EditProduct';
import AdminProducts from './pages/Manager/Products';

import AdminAddCategory from './pages/Manager/AddCategory';
import AdminCategories from './pages/Manager/Categories';
import AdminEditCategory from './pages/Manager/EditCategory';

import AdminAddType from './pages/Manager/AddType';
import AdminEditType from './pages/Manager/EditType';

import AdminAddGroup from './pages/Manager/AddGroup';
import AdminEditGroup from './pages/Manager/EditGroup';

import AdminAddVideo from './pages/Manager/AddVideo';
import AdminEditVideo from './pages/Manager/EditVideo';
import AdminVideos from './pages/Manager/ProductVideos';

import AdminAddImage from './pages/Manager/AddImage';
import AdminEditImage from './pages/Manager/EditImage';
import AdminImages from './pages/Manager/ProductImages';

import AdminAddFile from './pages/Manager/AddFile';
import AdminEditFile from './pages/Manager/EditFile';
import AdminFiles from './pages/Manager/ProductFiles';

import AdminAddFeatured from './pages/Manager/AddFeatured';
import AdminEditFeatured from './pages/Manager/EditFeatured';
import AdminFeatureds from './pages/Manager/Featureds';

import AdminAddDownloadType from './pages/Manager/AddDownloadType';
import AdminDownloads from './pages/Manager/Downloads';
import AdminEditDownloadType from './pages/Manager/EditDownloadType';

import AdminAddDownloadCategory from './pages/Manager/AddDownloadCategory';
import AdminDownloadCategories from './pages/Manager/DownloadCategories';
import AdminEditDownloadCategory from './pages/Manager/EditDownloadCategory';

import AdminAddDownloadFile from './pages/Manager/AddDownloadFile';
import AdminDownloadFiles from './pages/Manager/DownloadFiles';
import AdminEditDownloadFile from './pages/Manager/EditDownloadFile';

import AdminAddContact from './pages/Manager/AddContact';
import AdminContacts from './pages/Manager/Contacts';
import AdminEditContact from './pages/Manager/EditContact';
import AdminAddSocialLink from './pages/Manager/AddSocialLink';
import AdminEditSocialLink from './pages/Manager/EditSocialLink';

import AdminAddMember from './pages/Manager/AddMember';
import AdminEditMember from './pages/Manager/EditMember';
import AdminMembers from './pages/Manager/Members';

import AdminAddSeller from './pages/Manager/AddSeller';
import AdminEditSeller from './pages/Manager/EditSeller';
import AdminSellers from './pages/Manager/Sellers';

import AdminAddUser from './pages/Manager/AddUser';
import AdminEditUser from './pages/Manager/EditUser';
import AdminUsers from './pages/Manager/Users';

import AdminReports from './pages/Manager/Reports';

import ViewImage from './pages/Files/Image';
import ViewSupply from './pages/Files/Supply';
import ViewVideo from './pages/Files/Video';

import { NotificationProvider } from './Contexts/NotificationContext';

import { ModalProvider } from './Contexts/ModalContext';
import Error from './pages/Errors/Error';

const App = () => {
    return (
        <TokenProvider>
            <NotificationProvider>
                <ModalProvider>
                    <Router>
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route path="/alterar-senha/:token" element={<Password />} />
                            <Route path="/painel/" element={<ProtectedRoute element={<Home />} />} />
                            <Route path="/" element={<ProtectedRoute element={<HomeRedirect />} />} />

                            <Route path="/painel/produtos/:tipo" element={<ProtectedRoute element={<Type />} />} />
                            <Route path="/painel/produtos/:tipo/:slug" element={<ProtectedRoute element={<Product />} />} />
                            <Route path="/painel/produtos/:tipo/:slug/videos/:grupo" element={<ProtectedRoute element={<Videos />} />} />
                            <Route path="/painel/produtos/:tipo/:slug/videos/:grupo/:id" element={<ProtectedRoute element={<Video />} />} />
                            <Route path="/painel/produtos/:tipo/:slug/imagens/:grupo" element={<ProtectedRoute element={<Images />} />} />
                            <Route
                                path="/painel/produtos/:tipo/:slug/materiais/:grupo"
                                element={<ProtectedRoute element={<Supplies />} />}
                            />
                            <Route
                                path="/painel/produtos/:tipo/:slug/materiais/:grupo/:id"
                                element={<ProtectedRoute element={<Supply />} />}
                            />

                            <Route path="/painel/pesquisar" element={<ProtectedRoute element={<Search />} />} />

                            <Route path="/painel/news/destaques/" element={<ProtectedRoute element={<Featureds />} />} />
                            <Route path="/painel/news/destaques/:slug" element={<ProtectedRoute element={<Featured />} />} />
                            {/*<Route path="/painel/area-do-representante/ranking/" element={<ProtectedRoute element={<Ranking />} />} />*/}
                            <Route path="/painel/news/aniversarios/" element={<ProtectedRoute element={<Birthday />} />} />

                            <Route path="/painel/downloads/:tipo" element={<ProtectedRoute element={<Download />} />} />

                            <Route path="/painel/contato" element={<ProtectedRoute element={<Contact />} />} />

                            <Route path="/painel/perfil" element={<ProtectedRoute element={<Profile />} />} />
                            <Route path="/cadastro/finalizar-cadastro" element={<ProtectedRoute element={<CompleteRegister />} />} />
                            <Route path="/cadastro/termos-de-uso" element={<ProtectedRoute element={<AcceptTerms />} />} />

                            <Route path="/manager/login" element={<AdminLogin />} />
                            <Route path="/manager/" element={<ProtectedRoute admin={true} element={<AdminHome />} />} />
                            <Route path="/manager/slides/adicionar" element={<ProtectedRoute admin={true} element={<AdminAddSlide />} />} />
                            <Route
                                path="/manager/slides/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditSlide />} />}
                            />

                            <Route path="/manager/produtos" element={<ProtectedRoute admin={true} element={<AdminProducts />} />} />
                            <Route
                                path="/manager/produtos/adicionar"
                                element={<ProtectedRoute admin={true} element={<AdminAddProduct />} />}
                            />
                            <Route
                                path="/manager/produtos/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditProduct />} />}
                            />

                            <Route path="/manager/categorias" element={<ProtectedRoute admin={true} element={<AdminCategories />} />} />
                            <Route
                                path="/manager/categorias/adicionar"
                                element={<ProtectedRoute admin={true} element={<AdminAddCategory />} />}
                            />
                            <Route
                                path="/manager/categorias/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditCategory />} />}
                            />

                            <Route path="/manager/tipos/adicionar" element={<ProtectedRoute admin={true} element={<AdminAddType />} />} />
                            <Route path="/manager/tipos/editar/:id" element={<ProtectedRoute admin={true} element={<AdminEditType />} />} />

                            <Route path="/manager/grupos/adicionar" element={<ProtectedRoute admin={true} element={<AdminAddGroup />} />} />
                            <Route
                                path="/manager/grupos/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditGroup />} />}
                            />

                            <Route
                                path="/manager/produtos/videos/:id"
                                element={<ProtectedRoute admin={true} element={<AdminVideos />} />}
                            />
                            <Route
                                path="/manager/videos/adicionar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminAddVideo />} />}
                            />
                            <Route
                                path="/manager/videos/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditVideo />} />}
                            />

                            <Route
                                path="/manager/produtos/imagens/:id"
                                element={<ProtectedRoute admin={true} element={<AdminImages />} />}
                            />
                            <Route
                                path="/manager/imagens/adicionar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminAddImage />} />}
                            />
                            <Route
                                path="/manager/imagens/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditImage />} />}
                            />

                            <Route
                                path="/manager/produtos/materiais/:id"
                                element={<ProtectedRoute admin={true} element={<AdminFiles />} />}
                            />
                            <Route
                                path="/manager/arquivos/adicionar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminAddFile />} />}
                            />
                            <Route
                                path="/manager/arquivos/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditFile />} />}
                            />

                            <Route path="/manager/destaques" element={<ProtectedRoute admin={true} element={<AdminFeatureds />} />} />
                            <Route
                                path="/manager/destaques/adicionar"
                                element={<ProtectedRoute admin={true} element={<AdminAddFeatured />} />}
                            />
                            <Route
                                path="/manager/destaques/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditFeatured />} />}
                            />

                            <Route path="/manager/downloads/tipos" element={<ProtectedRoute admin={true} element={<AdminDownloads />} />} />
                            <Route
                                path="/manager/downloads/tipos/adicionar"
                                element={<ProtectedRoute admin={true} element={<AdminAddDownloadType />} />}
                            />
                            <Route
                                path="/manager/downloads/tipos/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditDownloadType />} />}
                            />

                            <Route
                                path="/manager/downloads/categorias/:id"
                                element={<ProtectedRoute admin={true} element={<AdminDownloadCategories />} />}
                            />
                            <Route
                                path="/manager/downloads/categorias/adicionar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminAddDownloadCategory />} />}
                            />
                            <Route
                                path="/manager/downloads/categorias/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditDownloadCategory />} />}
                            />

                            <Route
                                path="/manager/downloads/arquivos/:id"
                                element={<ProtectedRoute admin={true} element={<AdminDownloadFiles />} />}
                            />
                            <Route
                                path="/manager/downloads/arquivos/adicionar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminAddDownloadFile />} />}
                            />
                            <Route
                                path="/manager/downloads/arquivos/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditDownloadFile />} />}
                            />

                            <Route path="/manager/contatos" element={<ProtectedRoute admin={true} element={<AdminContacts />} />} />
                            <Route
                                path="/manager/contatos/adicionar"
                                element={<ProtectedRoute admin={true} element={<AdminAddContact />} />}
                            />
                            <Route
                                path="/manager/contatos/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditContact />} />}
                            />

                            <Route
                                path="/manager/redes-sociais/adicionar"
                                element={<ProtectedRoute admin={true} element={<AdminAddSocialLink />} />}
                            />
                            <Route
                                path="/manager/redes-sociais/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditSocialLink />} />}
                            />

                            <Route path="/manager/usuarios-internos" element={<ProtectedRoute admin={true} element={<AdminMembers />} />} />
                            <Route
                                path="/manager/usuarios-internos/adicionar"
                                element={<ProtectedRoute admin={true} element={<AdminAddMember />} />}
                            />
                            <Route
                                path="/manager/usuarios-internos/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditMember />} />}
                            />

                            <Route path="/manager/representantes" element={<ProtectedRoute admin={true} element={<AdminSellers />} />} />
                            <Route
                                path="/manager/representantes/adicionar"
                                element={<ProtectedRoute admin={true} element={<AdminAddSeller />} />}
                            />
                            <Route
                                path="/manager/representantes/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditSeller />} />}
                            />

                            <Route path="/manager/usuarios" element={<ProtectedRoute admin={true} element={<AdminUsers />} />} />
                            <Route
                                path="/manager/usuarios/adicionar"
                                element={<ProtectedRoute admin={true} element={<AdminAddUser />} />}
                            />
                            <Route
                                path="/manager/usuarios/editar/:id"
                                element={<ProtectedRoute admin={true} element={<AdminEditUser />} />}
                            />

                            <Route path="/manager/relatorios" element={<ProtectedRoute admin={true} element={<AdminReports />} />} />

                            <Route path="/arquivos/:slug/videos/:id" element={<ViewVideo />} />
                            <Route path="/arquivos/:slug/imagens/:id" element={<ViewImage />} />
                            <Route path="/arquivos/:slug/materiais/:id" element={<ViewSupply />} />

                            <Route path="/erro/:tipo" element={<Error />} />
                            <Route path="*" element={<Error />} />
                        </Routes>
                    </Router>
                </ModalProvider>
            </NotificationProvider>
        </TokenProvider>
    );
};

export default App;
